import { FilterField } from "~/features/filter";

import { useCronLogNameOptions } from "./model/useCronLogNameOptions";

type Translate = (key: string) => string;

/**
 * Поля фильтра логов интеграций: наименование события — одиночный селект
 * (опции загружаются с GET /logs/cron/names), период — диапазон дат,
 * в URL хранится строками yyyy-MM-dd.
 * Имена полей совпадают с параметрами GET /logs/cron.
 */
export const integrationsLogsFilterFields = (t: Translate): FilterField[] => [
  {
    name: "name",
    type: "select",
    label: t("ui.event_name"),
    placeholder: t("ui.select"),
    optionsHook: useCronLogNameOptions,
  },
  {
    name: "start",
    nameTo: "end",
    type: "dateRange",
    label: t("ui.period"),
    placeholder: t("ui.from_date"),
    placeholderTo: t("ui.to_date"),
    fixedWidth: 360,
    disableFutureDates: true,
  },
];
